export default "__VITE_ASSET__e40c5118__"